export default "__VITE_ASSET__COAbUryT__"